module.exports = __webpack_public_path__ + "img/hello-world.e4ab6b61.png";